import {
  PageBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import userSettingsPlugin from '@backstage/plugin-user-settings/alpha';

export const userSettingsModule = createFrontendModule({
  pluginId: userSettingsPlugin.pluginId,
  extensions: [
    // ── Route (→ app/routes) ────────────────────────────────
    PageBlueprint.make({
      params: {
        path: '/settings',
        noHeader: true,
        routeRef: userSettingsPlugin.routes.root,
        loader: () =>
          import('../components/user-settings/SettingsPage').then(
            m => m.SettingsPage,
          ),
      },
    }),
  ],
});
